import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicePointFeatures } from '@deprecated/api-interfaces';
import { environment } from '../../environments/environment';
import { InteractionService } from '../shared/services/interaction.service';
import { TenantConfigService } from '../shared/services/tenant-config.service';

@Component({
  selector: 'app-visit-e-shop',
  templateUrl: './visit-e-shop.component.html',
  styleUrls: ['./visit-e-shop.component.scss'],
  standalone: false,
})
export class VisitEShopComponent implements OnInit {
  brandName: string;
  visitShopLink: string;
  deviceId: string;
  readonly learnMoreLink = 'https://www.elmorietschle.com/en/parts-and-service/';
  readonly requestQuoteLink = 'https://www.elmorietschle.com/en/request-a-quote/';

  constructor(
    private tenantConfigService: TenantConfigService,
    private interactionService: InteractionService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.brandName = window.location.href;
    this.deviceId = this.route.snapshot.paramMap.get('deviceId');
    this.visitShopLink = this.tenantConfigService.getServicePointFeatures()[ServicePointFeatures.VISIT_SHOP_LINK];
    if (this.deviceId) {
      this.interactionService.checkFeatureEvent(ServicePointFeatures.VISIT_E_SHOP_TILE, this.deviceId);
    }
  }

  openVisitShopLink(): void {
    if (this.visitShopLink) {
      this.interactionService.checkFeatureEvent(ServicePointFeatures.VISIT_SHOP_LINK, this.deviceId);
      window.open(this.visitShopLink, '_blank');
    }
  }

  openExternalLink(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
